import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';

// Définition de la requête GraphQL
const GET_USER_INVOICE_DEFAULTS = gql`
    query GetUser($uuid: ID!) {
        user(uuid: $uuid) {
            consultantInvoiceDefaults {
                monthlyCommissionEur
                dailyCommissionEur
                dailyRateConsultantEur
                manualCommission
            }
            consultantProfile {
                defaultCommissionPerWorkingDay
                defaultCommissionPerMonthInDailyRate
            }
        }
    }
`;

const useInvoiceDefaults = (uuid) => {

    const {loading, error, data, refetch} = useQuery(GET_USER_INVOICE_DEFAULTS, {
        variables: {uuid},
        fetchPolicy: 'network-only'
    });

    return {
        user: data?.user,
        loading,
        error,
        refetch
    };
};

export default useInvoiceDefaults;
